import Reveal from "@/components/Reveal";

/**
 * Operator credentials — 13yrs · €25M · 6+1 markets · Dublin.
 * Paired with two pull-quotes from the operator.
 */
const rows = [
  {
    n: <><em className="text-coral">13</em>yrs</>,
    l: (
      <>
        <b>Operating Amazon EU categories</b> — running them inside the machine, not advising
        from outside it.
      </>
    ),
  },
  {
    n: <>€<em className="text-coral">25</em>M</>,
    l: (
      <>
        <b>Largest account managed</b> — one multi-brand portfolio across six European markets,
        simultaneously.
      </>
    ),
  },
  {
    n: <><em className="text-coral">6</em>+1</>,
    l: (
      <>
        <b>Markets run</b> — DE, FR, IT, ES, NL, SE… and now Amazon.ie from the inside, for
        global consumer brands in Ireland.
      </>
    ),
  },
  {
    n: <>DUB<em className="text-coral">.</em></>,
    l: (
      <>
        <b>Based in Dublin</b> — at the start of the route every client brand travels.
      </>
    ),
  },
];

export default function OperatorStats() {
  return (
    <section className="bg-paper text-ink border-b border-line" data-testid="operator-stats">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 py-16 sm:py-20 lg:py-24">
        <Reveal>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-coral flex items-center gap-3.5 mb-5">
            <span className="w-9 h-px bg-coral" />
            Chapter 06 — The operator
          </p>
          <h2 className="font-serif-i italic text-[34px] sm:text-[44px] lg:text-[64px] leading-[.98] tracking-[-.035em] max-w-[880px] mb-14 text-ink">
            Built by someone who has
            <br />
            run the <em className="text-navy-mid">machine.</em>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] gap-12 lg:gap-16 items-start">
          {/* Stats column */}
          <div className="flex flex-col">
            {rows.map((r, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <div
                  data-testid={`operator-stat-${i}`}
                  className="flex items-baseline gap-6 py-6 border-b border-line last:border-b-0"
                >
                  <p
                    className="font-serif-i italic tracking-[-.045em] text-ink leading-[.85] min-w-[150px]"
                    style={{ fontSize: "clamp(40px, 4.4vw, 62px)" }}
                  >
                    {r.n}
                  </p>
                  <p className="text-[13.5px] font-light text-ink-muted leading-[1.6] pt-1 [&_b]:text-ink [&_b]:font-medium">
                    {r.l}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>

          {/* Quotes column */}
          <div>
            <Reveal delay={0.1}>
              <div className="relative bg-white border border-line px-10 py-10" data-testid="operator-quote-1">
                <span
                  aria-hidden="true"
                  className="absolute -top-7 left-6 font-serif-i italic text-coral leading-none opacity-[.16] pointer-events-none select-none"
                  style={{ fontSize: 130 }}
                >
                  &ldquo;
                </span>
                <p className="font-serif-i italic tracking-[-.018em] leading-[1.42] text-ink mb-5"
                   style={{ fontSize: "clamp(19px, 2vw, 24px)" }}>
                  Traeva takes a small number of brands each year and goes deep. The constraint
                  isn't a marketing line — <b className="text-coral font-normal">depth is the product.</b> If we
                  take you on, your launch gets the attention a €25M account did.
                </p>
                <p className="font-mono text-[9.5px] tracking-[0.18em] uppercase text-ink-low">
                  Founder · Traeva · Dublin
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.18}>
              <div
                className="relative bg-white border border-line px-10 py-10 mt-6"
                style={{ borderLeft: "3px solid #1A6B3A" }}
                data-testid="operator-quote-2"
              >
                <p className="font-serif-i italic tracking-[-.018em] leading-[1.42] text-ink mb-5"
                   style={{ fontSize: "clamp(19px, 2vw, 24px)" }}>
                  And when the honest answer is WAIT — we say WAIT. A brand that launches before
                  it's ready doesn't come back to Amazon for years.{" "}
                  <b className="text-coral font-normal">Protecting you from a bad launch is part of the service.</b>
                </p>
                <p className="font-mono text-[9.5px] tracking-[0.18em] uppercase text-ink-low">
                  On honest verdicts
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
